import { defineStore } from 'pinia';
import notificationWrapper from '@/utils/helpers/notificationWrapper';
import cookie from '@nextories/vue-core-components/src/utils/helpers/cookie';
import { useProjectStore } from './projectStore';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    isInit: false,
    isLogged: !!cookie.getCookie(import.meta.env.VITE_APP_COOKIE_TOKEN_NAME),
    isLoginLoading: false,
    isRecoverPasswordLoading: false,
    isResetPasswordLoading: false,
    isMinarm: false,
    isPasswordKeyLoading: false,
  }),

  actions: {
    init() {
      this.isInit = true;
    },

    async login(form: any) {
      this.isLoginLoading = true;
      try {
        const data = await window.appConnector.login(form);
        if (data) {
          this.isLogged = true;
          cookie.setCookie(
            import.meta.env.VITE_APP_COOKIE_TOKEN_NAME,
            data.token,
            import.meta.env.VITE_APP_COOKIE_TOKEN_DURATION,
          );
          this.isLoginLoading = false;
          return data;
        }
      } catch (error) {
        this.isLogged = false;
        notificationWrapper('error', 'LOGIN');
        this.isLoginLoading = false;
        throw error;
      }
    },

    async autoLogin(form: any) {
      this.isLoginLoading = true;
      try {
        const data = await window.appConnector.autoLogin(form);
        if (data) {
          this.isLogged = true;
          cookie.setCookie(
            import.meta.env.VITE_APP_COOKIE_TOKEN_NAME,
            data.token,
            import.meta.env.VITE_APP_COOKIE_TOKEN_DURATION,
          );
          this.isLoginLoading = false;
        }
      } catch (error) {
        this.isLogged = false;
        notificationWrapper('error', error && error.data
          ? error.data.error : '');
        this.isLoginLoading = false;
        throw error;
      }
    },

    async getImpersonationProjects() {
      if (import.meta.env.VITE_APP_IS_PROD === 'true') {
        return [];
      }
      return window.appConnector.getImpersonationProjects();
    },

    async recoverPassword(form: any) {
      this.isRecoverPasswordLoading = true;
      try {
        const data = await window.appConnector.recoverPassword(form);
        if (data) {
          notificationWrapper('success', 'RECOVER_PASSWORD');
          this.isRecoverPasswordLoading = false;
        }
      } catch (error) {
        notificationWrapper('error', 'RECOVER_PASSWORD');
        this.isRecoverPasswordLoading = false;
        throw error;
      }
    },

    async resetPassword(form: any) {
      this.isResetPasswordLoading = true;
      try {
        const data = await window.appConnector.resetPassword(form);
        if (data) {
          this.isLogged = true;
          cookie.setCookie(
            import.meta.env.VITE_APP_COOKIE_TOKEN_NAME,
            data.token,
            import.meta.env.VITE_APP_COOKIE_TOKEN_DURATION,
          );
          notificationWrapper('success', 'RESET_PASSWORD');
          this.isResetPasswordLoading = false;
        }
      } catch (error) {
        notificationWrapper('error', error?.data?.error);
        this.isResetPasswordLoading = false;
        throw error;
      }
    },

    async checkPasswordKey(form: any) {
      this.isPasswordKeyLoading = true;
      try {
        const data = await window.appConnector.checkPasswordKey(form);
        if (data?.success) {
          this.isMinarm = data.is_minarm;
          this.isPasswordKeyLoading = false;
        }
      } catch (error) {
        this.isPasswordKeyLoading = false;
        throw error;
      }
    },

    logout() {
      this.unsetIsLogged();
      // Remove projectSelectedStorage
      const projectStore = useProjectStore();
      localStorage.removeItem(projectStore.projectStorageKey);
      sessionStorage.removeItem(projectStore.projectStorageKey);
    },

    unsetIsLogged() {
      this.isLogged = false;
    },
  },
});
